import moment from 'moment';
import store from '../../store/index';
import { setReturnCalculator } from '../../store/todayReturnCalculator';

export const returnCalculator = (data: any, selectedIdentifiers: any, newTradeData: any, selectedDate: any) => {
    let lft_array: any = []
    let fno_array: any = []
    let equity_array: any = []
    let equityN50plus_array: any = []

    let equityN50BANK_array: any = []
    let equityN50IT_array: any = []


    let today_polynomial_return: any = 0
    let today_polynomial_return_aftercost: any = 0
    let optLong_array: any = []
    let today_fno_return: any = 0
    let today_lft_return: any = 0
    let today_equity_return: any = 0
    let today_fno_return_aftercost: any = 0
    let today_lft_return_aftercost: any = 0
    let today_equity_return_aftercost: any = 0
    let todayDate: any = moment(new Date()).format("YYYY-MM-DD")

    //New added //
    let today_n50bank_return:any = 0;
    let today_n50bank_return_aftercost:any = 0;

    let today_n50IT_return:any = 0;
    let today_n50IT_return_aftercost:any = 0;

    let equityBANK_array: any = []
    let equityIT_array: any = []


    let today_optLong_return: any = 0
    let today_optLong_returnAfterCost: any = 0

    let modelCodeType: any = 's_code';
    let modelReturnType: any = 'n_return';
    let modelReturnAfterCostType: any = 'n_return_after_cost';

    if (todayDate !== selectedDate) {
        modelCodeType = 'identifier';
        modelReturnType = 'return_per';
        modelReturnAfterCostType = 'return_after_cost';
    }
    if (data?.length > 0) {
        data?.map((item: any) => {
            let modelCode_: any = item[modelCodeType]
            try {       
                if(item[modelCodeType]?.includes('-') == true) {
                    modelCode_ = item[modelCodeType]?.split('-')[0]?.slice(0, -1) +'-'+item[modelCodeType]?.split('-')[1]
                }else{
                    modelCode_ = item[modelCodeType]?.split('-')[0]?.slice(0, -1)
                }  
                if ((modelCode_?.slice(1, 3) !== "ES") &&(modelCode_?.slice(0, 3) !== "QEB") && (modelCode_ !== "AIOBANDDI") && (modelCode_ !== "AIONIFDDI") && (modelCode_ !== "AIONIFKKI")) {
                    if (selectedIdentifiers?.includes(modelCode_)) {
                        if(modelCode_ === 'AIONIFMMI'){
                            today_fno_return += isNaN(Number(item['n_parallel_return'])) !== true ? Number(item['n_parallel_return']) : 0
                            today_fno_return_aftercost += isNaN(Number(item['n_parallel_return_after_cost'])) !== true ? Number(item['n_parallel_return_after_cost']) : 0
                        }
                        else{
                            today_fno_return += isNaN(Number(item[modelReturnType])) !== true ? Number(item[modelReturnType]) : 0
                            today_fno_return_aftercost += isNaN(Number(item[modelReturnAfterCostType])) !== true ? Number(item[modelReturnAfterCostType]) : 0
                        }
                        fno_array?.push(modelCode_)
                    }
                }
                else if ((modelCode_ === "AIOBANDDI") || (modelCode_ === "AIONIFDDI")) {
                    if (selectedIdentifiers?.includes(modelCode_)) {
                        lft_array?.push(modelCode_)
                        today_lft_return += isNaN(Number(item[modelReturnType])) !== true ? Number(item[modelReturnType]) : 0
                        today_lft_return_aftercost += isNaN(Number(item[modelReturnAfterCostType])) !== true ? Number(item[modelReturnAfterCostType]) : 0
                    }
                }
                else if (modelCode_?.slice(1, 3) === "ES") {
                    // console.log("This is the model code for equity", modelCode_)
                    if (selectedIdentifiers?.includes(modelCode_)) {
                        equity_array?.push(modelCode_)
                        today_equity_return += isNaN(Number(item['oneDay_return_per'])) !== true ? Number(item['oneDay_return_per']) : 0
                        today_equity_return_aftercost += isNaN(Number(item['oneDay_return_per'])) !== true ? Number(item['oneDay_return_per']) : 0
                    }
                }
                else if (modelCode_?.slice(0, 3) === "POL") {
                    if (selectedIdentifiers?.includes(modelCode_)) {
                        equityN50plus_array?.push(modelCode_)
                        today_polynomial_return += isNaN(Number(item['oneDay_return_per'])) !== true ? Number(item['oneDay_return_per']) : 0
                        today_polynomial_return_aftercost += isNaN(Number(item['oneDay_return_per'])) !== true ? Number(item['oneDay_return_per']) : 0
                    }
                }
                else if (modelCode_ === "AIONIFKKI") {
                    if (selectedIdentifiers?.includes(modelCode_)) {
                        today_optLong_return += isNaN(Number(item[modelReturnType])) !== true ? Number(item[modelReturnType]) : 0
                        today_optLong_returnAfterCost += isNaN(Number(item[modelReturnAfterCostType])) !== true ? Number(item[modelReturnAfterCostType]) : 0
                        optLong_array?.push(modelCode_)
                    }
                }

                else if (modelCode_?.slice(1, 3) === "EB") {
                    //FOR EQUITY BANK SECTION
                    if (selectedIdentifiers?.includes(modelCode_)) {
                        equityBANK_array?.push(modelCode_)
                        today_n50bank_return += isNaN(Number(item['oneDay_return_per'])) !== true ? Number(item['oneDay_return_per']) : 0
                        today_n50bank_return_aftercost += isNaN(Number(item['oneDay_return_per'])) !== true ? Number(item['oneDay_return_per']) : 0
                    }
                }
                else if (modelCode_?.slice(0, 3) === "EQIT") {

                    //FOR EQUITY IT SECTION
                    if (selectedIdentifiers?.includes(modelCode_)) {
                        equityIT_array?.push(modelCode_)
                        today_n50IT_return += isNaN(Number(item['oneDay_return_per'])) !== true ? Number(item['oneDay_return_per']) : 0
                        today_n50IT_return_aftercost += isNaN(Number(item['oneDay_return_per'])) !== true ? Number(item['oneDay_return_per']) : 0
                    }
                }
            }
            catch (error) {
                console.log(`Exception while calculating the return for today, modal code -> ${modelCode_}`, error)
            }
        })

        let totalLFTSelectedModals: any = [...new Set(lft_array)]
        let totalFNOSelectedModals: any = [...new Set(fno_array)]
        let totalEQSelectedModals: any = [...new Set(equity_array)]
        let totalPOLSelectedModals: any = [...new Set(equityN50plus_array)]
        let totalOptLongSelectedModals: any = [...new Set(optLong_array)]

        //New added 
        let totalEQBANKSelectedModals: any = [...new Set(equityBANK_array)]
        let totalEQITSelectedModals: any = [...new Set(equityIT_array)]

        let totalSelectedModelsOPT: any = Number(([...totalLFTSelectedModals, ...totalFNOSelectedModals, ...totalOptLongSelectedModals])?.length)

        let totalSelectedModelsEQ: any = Number(([...totalEQSelectedModals])?.length)
        let totalSelectedModelsBANK: any = Number(([...totalEQBANKSelectedModals])?.length)        

        let todayReturnArray: any = {
            "today_average_return"              : (totalSelectedModelsOPT > 0) ? (Number((Number(today_fno_return) + Number(today_lft_return) + Number(today_optLong_return))) / Number(totalSelectedModelsOPT)) : null,
            "today_average_return_after_cost"   : (totalSelectedModelsOPT > 0) ? (Number(Number(today_fno_return_aftercost) + Number(today_lft_return_aftercost) + Number(today_optLong_returnAfterCost))  / Number(totalSelectedModelsOPT)) : null,
            
            "today_average_return_eq"           : (Number((Number(Number(today_equity_return) + Number(today_n50bank_return))  / Number(Number(totalSelectedModelsEQ) + Number(totalSelectedModelsBANK))))) ,
            "today_average_return_after_cost_eq": (Number(Number(today_equity_return_aftercost) + Number(today_n50bank_return_aftercost)) / Number(Number(totalSelectedModelsEQ) + Number(totalSelectedModelsBANK))) ,

            "today_fno_return"                  : (totalFNOSelectedModals?.length > 0)  ? ((Number(today_fno_return) / Number(totalFNOSelectedModals?.length))) : null,
            "today_fno_returnAfterCost"         : (totalFNOSelectedModals?.length > 0)  ? ((Number(today_fno_return_aftercost) / Number(totalFNOSelectedModals?.length))) : null,
            "today_lft_return"                  : (totalLFTSelectedModals?.length > 0)  ? Number(today_lft_return) / Number(totalLFTSelectedModals?.length) : null,
            "today_lft_returnAfterCost"         : (totalLFTSelectedModals?.length > 0)  ? (Number(today_lft_return_aftercost) / Number(totalLFTSelectedModals?.length)) : null,
            "today_eq_return"                   : (totalEQSelectedModals?.length > 0)   ? Number(today_equity_return) / Number(totalEQSelectedModals?.length) : null,
            "today_eq_returnAfterCost"          : (totalEQSelectedModals?.length > 0)   ? (Number(today_equity_return_aftercost) / Number(totalEQSelectedModals?.length)) : null,
            "today_eqN50plus_return"            : (totalPOLSelectedModals?.length > 0)  ? Number(today_polynomial_return) / Number(totalPOLSelectedModals?.length) : null,
            "today_eqN50plus_returnAfterCost"   : (totalPOLSelectedModals?.length > 0)  ? (Number(today_polynomial_return_aftercost) / Number(totalPOLSelectedModals?.length)) : null,
            "today_optLong_return"              : (totalOptLongSelectedModals?.length > 0) ? Number(today_optLong_return) / Number(totalOptLongSelectedModals?.length) : null,
            "today_optLong_returnAfterCost"     : (totalOptLongSelectedModals?.length > 0) ? Number(today_optLong_returnAfterCost) / Number(totalOptLongSelectedModals?.length) : null,
            "today_eqBANK_return"               : (totalEQBANKSelectedModals?.length > 0) ? Number(today_n50bank_return) / Number(totalEQBANKSelectedModals?.length) : null,
            "today_eqBANK_returnAfterCost"      : (totalEQBANKSelectedModals?.length > 0) ? Number(today_n50bank_return_aftercost) / Number(totalEQBANKSelectedModals?.length) : null,
            "today_eqIT_return"                 : (totalEQITSelectedModals?.length > 0) ? Number(today_n50IT_return) / Number(totalEQITSelectedModals?.length) : null,
            "today_eqIT_returnAfterCost"        : (totalEQITSelectedModals?.length > 0) ? Number(today_n50IT_return_aftercost) / Number(totalEQITSelectedModals?.length) : null,
        }

        store.dispatch(setReturnCalculator([todayReturnArray]))

        return [todayReturnArray]
    }
    else {
        return []
    }
}

